const templates = {
  "Low Battery at Origin": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Low Battery at Origin",
    body: `Hi {{from_location.primary_contact_name}},

The sensor placed with shipment {{courier_tracking_id}} has {{battery_level}}% battery - below our recommended {{battery_charge_at_origin_pct}}% for a pre-pick shipment.

Please make sure to charge the sensor, or swap it with another sensor before the scheduled {{scheduled_pickup_date}} pickup.

Kindly reply to this email with the action you've taken, and to share the new Device ID, if you replaced the sensor.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Driver Late to Pick-Up": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Driver Late to Pick-Up",
    body: `Hi {{transport_provider.primary_contact_name}},

The driver is running more than {{late_to_pickup_buffer_minutes}} minutes late for the scheduled pickup of shipment {{courier_tracking_id}}. This might impact ETA, so please contact the driver immediately.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Flight Delay": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Flight Delay",
    body: `Hi {{transport_provider.primary_contact_name}},

We detected that flight {{flight_number}} expected to carry shipment {{courier_tracking_id}} is delayed by more than {{flight_delay_buffer_minutes}} mins.

Airport location: {{flight.source_airport_code}}.
New estimated departure time:{{flight.estimated_off}}.

We suggest confirming new times with the airline and potentially consider alternate flight options if needed.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Shipment Not Loaded Onto Flight": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Shipment Not Loaded Onto Flight",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} doesn't appear to have been loaded onto the scheduled flight {{flight_number}}. Please contact the airline immediately to have it loaded onto the next flight.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Offload Delay After Flight Arrival": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Offload Delay After Flight Arrival",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} has arrived at Airport {{airport_code}} but is taking longer than expected to offload. We suggest contacting the receiving facility to expedite offloading.

Current status: Arrived but not yet offloaded.
Delay: more than {{slow_to_offload_buffer_minutes}} beyond standard offloading time.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Driver Late to Recover Shipment": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Driver Late to Recover Shipment",
    body: `Hi {{transport_provider.primary_contact_name}},

The driver is taking longer than expected to recover shipment {{courier_tracking_id}} after offboarding confirmation. This delay may affect final delivery and compromise the product's timeline.

Please contact the carrier immediately to confirm the new pickup time and consider alternate arrangements if necessary.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Driver can't find location": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Driver can't find location",
    body: `Hi {{transport_provider.primary_contact_name}},

The driver can't find the drop-off location for shipment {{courier_tracking_id}}. Our records show the driver has reached the destination vicinity but hasn't completed delivery within the alloted {{cant_find_location_buffer_minutes}} minutes.

Please contact the driver and recipient immediately to coordinate delivery.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Delivered To The Wrong Address": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Delivered To The Wrong Address",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} appears to have been delivered to the wrong address. The GPS coordinates at delivery deviate from the address on file by more than {{wrong_address_buffer_feet}} ft.

Please contact the driver immediately to verify the actual delivery location and arrange for redelivery to the correct address.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Delivered To Wrong Recipient": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Delivered To Wrong Recipient",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} may have been delivered to an unauthorized recipient. Our records show the name on the proof of delivery (POD) does not match the intended recepients name.

Please contact the recipient and driver.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Flight Landing Close to Cargo Closing Time": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Flight Landing Close to Cargo Closing Time",
    body: `Hi {{transport_provider.primary_contact_name}},

Flight {{flight_number}} carrying shipment {{courier_tracking_id}} is scheduled to land at {{flight.scheduled_on}}, which is too close to the cargo closing hours ({{cargo_closing_hours}}) at the recovery airport. There may not be enough time to retrieve your shipment before the facility closes.

Please contact the airline or airport cargo team to reschedule or make special arrangements to avoid overnight delays.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Weather Event Impact Expected": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Weather Event Impact Expected",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} is expected to cross a weather event of severity Level {{weather_event_severity}} (scale of 1-5). Levels 3 and above typically require route adjustments or additional precautions, as severe weather can significantly delay or disrupt shipments.

Please contact the drive to evaluate rerouting or protective measures. Consider expediting to minimize the impact on product integrity.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Status Update Overdue": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Status Update Overdue",
    body: `Hi {{transport_provider.primary_contact_name}},

No status update has been recorded for shipment {{courier_tracking_id}} in over {{status_update_overdue_minutes}} minutes.

Please reach out to the driver or shipment handler to obtain a current status update and ensure timely delivery.

Kindly reply to this email with the information you've gathered.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Vehicle Idle In Transit": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Vehicle Idle In Transit",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} has remained idle for more than {{not_moving_time_threshold_minutes}} mins while in transit. This is unusual for this route and might indicate a logistics issue that could impact your delivery timeline.

Please contact the driver to verify the shipment's status, request an updated ETA, and consider an alternative route if necessary.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Temperature": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Temperature Nearing Limit",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} is nearing its limit, and is at risk of a temperature excursion.

Current temperature: {{current_temp}}.
Acceptable range: {{temp_range}}.

Please evaluate the package's coolant and insulation integrity. Re-ice the package, or consider moving the package to a temperature controlled environment to avoid an excursion.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Temperature Excursion": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Temperature Excursion",
    body: `Hi {{transport_provider.primary_contact_name}},

A temperature excursion with shipment {{courier_tracking_id}} has been detected. The shipment temperature has gone outside of it's allowable range for more than {{temp_excursion_buffer_minutes}} minutes.

Current temperature: {{current_temp}}.
Acceptable range {{temp_range}}.

Please immediately check the coolant and insulation integrity. Consider transferring the shipment to a more reliable temperature-controlled setup if needed.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Viability Window at risk of expiring before delivery": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Viability Window at risk of expiring before delivery",
    body: `Hi {{transport_provider.primary_contact_name}},

The viability window for shipment {{courier_tracking_id}} is at risk of expring before reaching its destination.

There are {{remaining_viability_window}} hours remaining, yet the estimated transit time is {{estimated_transit_time_remaining}}. To preserve product integrity, consider expediting the shipment or finding an alternative route by calling the driver.

Please act immediately to safeguard the shipment by contacting the shipment handler to re-ice, refrigerate, or expedite the shipment.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Viability window nearly exhausted": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Viability window nearly exhausted",
    body: `Hi {{transport_provider.primary_contact_name}},

The viability window for shipment {{courier_tracking_id}} is less than {{viability_to_expiration_buffer_minutes}} minutes away from being exhausted, signaling an imminent risk to product stability. Consider expediting the shipment or finding an alternative route.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Viability Window Exhausted": {
    subject:
      "Alert: [Shipment {{courier_tracking_id}}] - Viability Window Exhausted",
    body: `Hi {{transport_provider.primary_contact_name}},

The viability time for shipment {{courier_tracking_id}} has fully expired for longer than {{viability_exhausted_buffer_minutes}} minutes. This indicates a high risk of compromised product integrity.

Please consult with the carrier immediately to determine if there are any salvageable options. If the product is temperature-sensitive or has strict viability constraints, you may need to arrange for disposal or re-order to ensure patient/customer safety.

Kindly reply to this email with your decision or the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Shock Detected": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Shock Detected",
    body: `Hi {{transport_provider.primary_contact_name}},

The sensor in shipment {{courier_tracking_id}} detected a significant impact or shock.
Impact time: {{impact_time}}.
Severity: {{impact_level}}.

Please inspect the shipment and consider requesting a CAPA.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Light Exposure": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Light Exposure",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} appears to have been exposed to light. This could mean the shipment was opened. We recommend inspecting the shipment and checking product integrity.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Low Battery": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Low Battery",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} sensor battery has dropped below {{battery_charge_in_transit_pct}}%. This may not be enough to transmit data for the remainder of the trip. Please reach out to the driver to recharge the battery or place a fully charged sensor in the shipment.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Excessive Tilt": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Excessive Tilt",
    body: `Hi {{transport_provider.primary_contact_name}},

A sensor in shipment {{courier_tracking_id}} indicates it has been tilted beyond the allowable angle of {{tilt_threshold_deg}}°.

Current recorded tilt: {{tilt_angle_recorded}}°.

This can affect the product's integrity, especially when orientation is critical for stability or safety.

Please arrange an inspection to assess any potential damage or risk to the product.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Excessive Pressure": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Excessive Pressure",
    body: `Hi {{transport_provider.primary_contact_name}},

The sensor in shipment {{courier_tracking_id}} has registered a pressure level above the allowed threshold of {{pressue_threshold_psi}} psi. This could indicate improper stacking, atmospheric pressure changes, or handling issues.

Please coordinate with the driver to investigate the cause and evaluate whether immediate handling adjustments are needed.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
  "Excessive Humidity": {
    subject: "Alert: [Shipment {{courier_tracking_id}}] - Excessive Humidity",
    body: `Hi {{transport_provider.primary_contact_name}},

Shipment {{courier_tracking_id}} has recorded humidity levels above {{humidity_threshold_pct}}%. Such conditions may compromise product stability ifmoisture-sensitive items are being shipped.

Please check the packaging, desiccants, or protective measures in place to maintain appropriate humidity levels.Consider re-packing or relocating to a controlled environment if necessary.

Kindly reply to this email with the action you've taken.

Thanks,
{{sender_name}}, {{sender_role}}
{{sender_company}}

{{shipment_details}}`,
  },
};

const getAddressString = (location) => {
  if (!location || !location.address) return "";
  return location.address;
};

const getShipmentDetails = (shipment) => {
  if (!shipment) return "";

  const details = ["Shipment Details:"];
  if (shipment.courier_tracking_id) {
    details.push(`- Shipment: ${shipment.courier_tracking_id}`);
  }
  
  if (shipment.from_location?.address) {
    let from = `- From: ${shipment.from_location.address}`;
    if (shipment.actual_pickup_date || shipment.scheduled_pickup_date) {
      from += ` (departure: ${shipment.actual_pickup_date || shipment.scheduled_pickup_date})`;
    }
    details.push(from);
  }

  if (shipment.to_location?.address) {
    let to = `- To: ${shipment.to_location.address}`;
    if (shipment.estimated_delivery_date) {
      to += ` (delivery: ${shipment.estimated_delivery_date})`;
    }
    details.push(to);
  }

  if (shipment.product?.temperature_range) {
    details.push(`- Temperature Requirements: ${shipment.product.temperature_range}`);
  }

  return details.join("\n");
};

export const generateEmailParts = ({ alert, shipment, decodedToken }) => {
  const alertName = alert?.title;
  // Find the template key case-insensitively
  const templateKey = Object.keys(templates).find(
    (key) => key.toLowerCase() === alertName?.toLowerCase()
  );

  if (!templateKey) {
    return {
      subject: `Alert: ${alertName} – Immediate Attention Required`,
      body: `Hi,

An alert "${alertName}" has been triggered for shipment ${
        shipment?.courier_tracking_id
      }.

Please investigate.

Thanks,
${decodedToken?.company_name} Support`,
    };
  }

  let { subject, body } = templates[templateKey];
  const shipmentDetails = getShipmentDetails(shipment);

  const replacements = {
    "{{courier_tracking_id}}": shipment?.courier_tracking_id,
    "{{from_location.primary_contact_name}}": shipment?.from_location?.name,
    "{{battery_level}}": alert?.trigger?.currentValue,
    "{{battery_charge_at_origin_pct}}": alert?.trigger?.thresholdValue,
    "{{scheduled_pickup_date}}": shipment?.scheduled_pickup_date,
    "{{pickup_date}}":
      shipment?.actual_pickup_date || shipment?.scheduled_pickup_date,
    "{{sender_name}}": decodedToken?.name,
    "{{sender_role}}": decodedToken?.role || "Support",
    "{{sender_company}}": decodedToken?.company_name,
    "{{estimated_delivery_date}}": shipment?.estimated_delivery_date,
    "{{temp_range}}": shipment?.product?.temperature_range,
    "{{transport_provider.primary_contact_name}}":
      shipment?.tp_primary_contact?.name,
    "{{late_to_pickup_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{flight_number}}": alert?.context?.flight_number,
    "{{flight_delay_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{flight.source_airport_code}}": alert?.context?.source_airport_code,
    "{{flight.scheduled_on}}": alert?.context?.scheduled_on,
    "{{flight.estimated_off}}": alert?.context?.estimated_off,
    "{{airport_code}}": alert?.context?.airport_code,
    "{{slow_to_offload_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{cant_find_location_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{wrong_address_buffer_feet}}": alert?.trigger?.thresholdValue,
    "{{cargo_closing_hours}}": alert?.context?.cargo_closing_hours,
    "{{weather_event_severity}}": alert?.context?.weather_event_severity,
    "{{status_update_overdue_minutes}}": alert?.context?.overdue_duration,
    "{{not_moving_time_threshold_minutes}}": alert?.trigger?.thresholdValue,
    "{{current_temp}}": alert?.trigger?.currentValue,
    "{{temp_excursion_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{remaining_viability_window}}": alert?.context?.remaining_viability_window,
    "{{estimated_transit_time_remaining}}":
      alert?.context?.estimated_transit_time_remaining,
    "{{viability_to_expiration_buffer_minutes}}":
      alert?.trigger?.thresholdValue,
    "{{viability_exhausted_buffer_minutes}}": alert?.trigger?.thresholdValue,
    "{{impact_time}}": alert?.trigger?.timestamp,
    "{{impact_level}}": alert?.trigger?.currentValue,
    "{{battery_charge_in_transit_pct}}": alert?.trigger?.thresholdValue,
    "{{tilt_threshold_deg}}": alert?.trigger?.thresholdValue,
    "{{tilt_angle_recorded}}": alert?.trigger?.currentValue,
    "{{pressue_threshold_psi}}": alert?.trigger?.thresholdValue,
    "{{humidity_threshold_pct}}": alert?.trigger?.thresholdValue,
    "{{shipment_details}}": shipmentDetails,
  };

  for (const placeholder in replacements) {
    const regex = new RegExp(
      placeholder.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"),
      "g"
    );
    const value = replacements[placeholder] ?? "";
    subject = subject.replace(regex, value);
    body = body.replace(regex, value);
  }

  return { subject, body };
}; 
